import type { Layer } from '@pn/core/domain/layer';
import { isNil } from 'lodash-es';
import type { MapboxIMap } from '..';

export function hasLayer(this: MapboxIMap, layerId: Layer['id']) {
  return !isNil(this._native.getLayer(layerId));
}
